import React from 'react';
import { get } from '../../utils/request';
import { Spinner } from 'react-bootstrap';
import "../../dataProvider/buckets.js";
import Alert from "../../component/Alert/Alert";
import Badge from "../../component/Badge/Badge";
import Button from "../../component/Button/Button";
import Layout from "../../component/Layout/Layout";
import Link from "../../component/Link/Link";
import {faBucket, faCogs} from "@fortawesome/free-solid-svg-icons";
import "../../component/Table/Table.scss"


class Buckets extends React.Component {
    constructor(props) {
        super(props);

        const locationState = props.location.state || {};
        this.state = {
            buckets: [],
            errorMessage: "",
            loading: true,
            loadingSuccess: false,
            successMessage: locationState.successMessage || "",
        };
        this.loadData = this.loadData.bind(this);
    }

    async loadData() {
        const [res, err] = await get(this, "/auth/bucket/list");
        if (err) {
            this.setState({errorMessage: "error: " + err, loading: false});
            return
        }
        this.setState({buckets: res.data.Buckets, loading: false, loadingSuccess: true});
    }

    componentDidMount() {
        this.loadData();
        if (this.props.history.location.state) {
            this.props.history.replace({ pathname: '/buckets', state: {} });
        }
    }

    render() {
        const { buckets, errorMessage, loading, loadingSuccess, successMessage } = this.state;
        const { history } = this.props;

        const homepageUrl = `${process.env.REACT_APP_HOMEPAGE_URL}`;

        const cleanedBuckets = [];
        if (buckets) {
            buckets.forEach((item) => {
                let cleanedVersioning = item.versioning;
                if (!item.versioning) {
                    cleanedVersioning = 'Unversioned';
                }

                let objectLockStatus = 'Disabled';
                if (item.objectLock) {
                    objectLockStatus = 'Enabled';
                }
                cleanedBuckets.push({
                    name: item.name,
                    location: item.locationUid,
                    status: item.status,
                    versioning: cleanedVersioning,
                    objectLock: objectLockStatus
                });
            });
        }

        return <Layout activeMenu="/buckets" isLoggedIn={true}>
            <h1>Buckets</h1>
            {loading &&
            <>
                <Spinner animation="border" variant="primary"/> Loading buckets...
                <br/><br/>
            </>
            }
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            {successMessage && <Alert variant="success">{successMessage}</Alert>}
            {loadingSuccess &&
            <>
            <div className="d-flex">
                <Button className="primary btn btn-margin btn-right" faIcon={faBucket} label="Create bucket" onClick={() => history.push('/buckets/create')}/>
            </div>
            {!buckets &&
            <Alert variant="info">
                You don't have any buckets, yet.
                <br/>Bucket is like a high level folder and many programs need the bucket created before you can use it.
                <br/>Create at least one bucket.
            </Alert>
            }
                {buckets &&
                    <table className="table-ctr">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Location</th>
                            <th>Versioning</th>
                            <th>Object Lock</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {cleanedBuckets.map((value, index) => {

                            let versioningBadge = "";

                            if(value.versioning === "Suspended") {
                                versioningBadge = <Badge className="badge-danger-filled" label="suspended"/>;
                            } else if (value.versioning === "Enabled") {
                                versioningBadge = <Badge className="badge-success-filled" label="enabled"/>;
                            } else if (value.versioning === "Unversioned") {
                                versioningBadge = <Badge className="badge-cancel-filled" label="unversioned"/>;
                             }

                            let objectLockBadge = "";

                            if(value.objectLock === "Disabled") {
                                objectLockBadge = <Badge className="badge-danger-outline" label="disabled"/>;
                            } else if (value.objectLock === "Enabled") {
                                objectLockBadge = <Badge className="badge-success-outline" label="enabled"/>;
                            }

                            const isStatusOk = value.status === 'ok';

                            return <tr key={index}>
                                <td data-label={"Name"}>
                                    {isStatusOk ? (
                                        <Link className="lnk" href={"/buckets/" + value.location + "/" + value.name} label={value.name}/>
                                    ) : (
                                        <span>{value.name}</span>
                                    )}
                                    {!isStatusOk && (
                                        <div><small className="text-muted">{value.status}</small></div>
                                    )}
                                </td>
                                <td data-label={"Location"}>{value.location}</td>
                                <td data-label={"Versioning"}>{versioningBadge}</td>
                                <td data-label={"Object Lock"}>{objectLockBadge}</td>
                                <td>
                                    {isStatusOk && (
                                        <Link className="btn primary-outline" faIcon={faCogs} href={"/buckets/" + value.location + "/" + value.name} label="Properties"/>
                                    )}
                                </td>
                            </tr>
                        })}
                        </tbody>
                    </table>
                }
            <br/>
            <Alert variant="info">
                <b>For technical configurations, please consult our documentation:</b> <br/>
                <a href={homepageUrl+'/integrations'} target="_blank" rel="noopener">Integration manuals</a> <br/>
                <a href={homepageUrl+'/resources/regions'} target="_blank" rel="noopener">Regions</a>
            </Alert>
            </>
            }
        </Layout>;
    }
}

export default Buckets